<div class="wrapper" [ngClass]="{'inLogin': !showWrapper}" >
    <app-sidebar *ngIf="showWrapper == true"></app-sidebar>
    <div class="content-wrapper">
      <app-header (openChat)="getChatOpen($event)" *ngIf="showWrapper == true"></app-header>
      <div class="" [style.height]="isRequestTaskRoute ? '100vh' : null">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-chatpanel  *ngIf="showWrapper == true && showChat"
    (hideChat)="getChatclose($event)"
    (openChatWindow)=getopenChatWindow($event)
    [ngClass]="{'open': showChat, 'showChat': showChatWindow }">
  </app-chatpanel>


  <!-- <app-flowtrics-bot></app-flowtrics-bot> -->
</div>
 
